module.exports = __webpack_public_path__ + "static/img/rules-title.e69e371.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/519celebrate/rules-title.png
// module id = 83F8
// module chunks = 0